<template>
  <div class="chart_box" :style="{ width: '93%', height: barBoxHeight + 'px' }">
    <div
      :style="{ width: '100%', height: barChartHeight + 'px' }"
      ref="barChartRef"
    ></div>
  </div>
</template>
<script>
import * as echarts from "echarts";
export default {
  props: {
    viewCentre: {
      type: Object,
      required: true,
    },
  },
  name: "cylinderLog",
  data() {
    return {
      option: {
        title: {
          text: "",
          left: "center",
          textStyle: {
            color: "#FFF",
          },
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            color: "#FFF",
            fontweight: "bloder",
            fontSize: 10,
            interval: 0,
            formatter: function (value) {
              var ret = ""; //拼接加\n返回的类目项
              var maxLength = 5; //每项显示文字个数
              var valLength = value.length; //X轴类目项的文字个数
              var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
              if (rowN > 1) {
                //如果类目项的文字大于3,
                for (var i = 0; i < rowN; i++) {
                  var temp = ""; //每次截取的字符串
                  var start = i * maxLength; //开始截取的位置
                  var end = start + maxLength; //结束截取的位置
                  //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                  temp = value.substring(start, end) + "\n";
                  ret += temp; //凭借最终的字符串
                }
                return ret;
              } else {
                return value;
              }
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#FFF",
            fontweight: "bloder",
            fontSize: 15,
          },
        },
        series: [
          {
            data: [],
            type: "bar",
            itemStyle: { color: "#00a8f3" },
          },
        ],
      },
      screenWidth: 0,
      screenHeight: 0,
      barChartHeight: 380,
      barBoxHeight: 450,
    };
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize());
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
      this.barBoxHeight = (this.screenHeight - 170) / 2;

      const echart = echarts.init(this.$refs.barChartRef);
      this.barChartHeight = this.screenHeight / 2 - 60;
      // 更新饼图容器的样式
      this.$refs.barChartRef.style.height = this.barChartHeight + "px";
      this.option.title.text = this.viewCentre.item_name;
      this.option.xAxis.data = this.viewCentre.item_xdata;
      this.option.series[0].data = this.viewCentre.series_data;
      echart.resize();
      echart.setOption(this.option);
    },
  },
  beforeDestroy() {
    // 在组件销毁前移除窗口大小变化的监听器，以防止内存泄漏
    window.removeEventListener("resize", this.handleResize());
  },
};
</script>

<style scoped>
.chart_box {
  box-shadow: 0 0 30px 0 rgba(0, 128, 202, 0.8) inset;
  border-radius: 0.02rem;
  margin: 20px;
  padding: 10px;
}
</style>
